import {memo, useMemo} from 'react'
import {Button, CopyButton} from '@/shared/ui'
import {cn} from '@/shared/lib/cn'
import {FocusHintButton} from '@/pages/room/ui/focus-hint'
import {LogOut} from 'lucide-react'
import {RecordingIndicator} from '@/pages/room/room-recording'

interface RoomHeaderProps {
  roomId: string
  onLeave: () => void
  inCall?: boolean
  focusHintOpen?: boolean
  onFocusHintOpenChange?: (open: boolean) => void
  showRecordingIndicator?: boolean
}

/**
 * Room header with invite button, focus hint, and leave button
 */
export const RoomHeader = memo(function RoomHeader({
  roomId,
  onLeave,
  inCall,
  focusHintOpen,
  onFocusHintOpenChange,
  showRecordingIndicator = false,
}: RoomHeaderProps) {
  const roomLink = useMemo(() => `${window.location.origin}/room/${roomId}`, [roomId])
  const showHint = focusHintOpen !== undefined && onFocusHintOpenChange !== undefined

  return (
    <header
      className={cn(
        'shrink-0 flex justify-center px-6 py-3 max-sm:py-2 max-sm:pb-1 max-sm:px-3',
        inCall && 'max-md:bg-card/95',
      )}
    >
      <div className="flex w-full max-w-7xl items-center justify-between gap-4">
        <div className="flex shrink-0 items-center gap-3">
          {showRecordingIndicator && <RecordingIndicator />}
          <CopyButton textToCopy={roomLink} variant="secondary" size="sm" copiedText="Скопировано!">
            Пригласить
          </CopyButton>
        </div>
        <div className="flex shrink-0 items-center gap-2">
          {showHint && (
            <FocusHintButton open={focusHintOpen} onOpenChange={onFocusHintOpenChange} />
          )}
          <Button variant="destructive" size="sm" onClick={onLeave}>
            <LogOut size={16} />
            <span className="max-sm:hidden">Выйти</span>
          </Button>
        </div>
      </div>
    </header>
  )
})
